module.exports = __webpack_public_path__ + "img/storage.4745d163.svg";